import { fetchLocalServices } from './apiClients/LocalhostApi';
import { getSessionStorage } from './apiClients/global';
export const CHIRP_SKIP_LOCAL_KEY = 'CHIRP_SKIP_LOCAL';
export const CHIRP_FORCE_401_KEY = 'CHIRP_FORCE_401';
let localServicesPromise = null;

// we aren't allowed enviro here due to npm-shim constraints
function matchesLocation(hostnamePattern, pathPrefix) {
  try {
    if (typeof window === 'undefined') {
      return false;
    }
    const {
      hostname,
      pathname
    } = window.location;
    return hostnamePattern.test(hostname) && (pathPrefix === undefined || pathname.startsWith(pathPrefix));
  } catch (_unused) {
    return false;
  }
}
function isQA() {
  return matchesLocation(/qa\./);
}
function isGoggles() {
  return matchesLocation(/(tools|private|local)\.hubteam(qa)?\.com/, '/api');
}
function getSessionStorageFlag(key) {
  const sessionStorage = getSessionStorage();
  if (!sessionStorage || typeof sessionStorage.getItem !== 'function') {
    return false;
  }
  try {
    return sessionStorage.getItem(key) === 'true';
  } catch (_unused2) {
    return false;
  }
}
function shouldSkipLocal() {
  return getSessionStorageFlag(CHIRP_SKIP_LOCAL_KEY);
}
function fetchLocalServicesCached() {
  if (!localServicesPromise) {
    localServicesPromise = fetchLocalServices().catch(() => []);
  }
  return localServicesPromise;
}
export async function resolveLocalRequest(serviceName) {
  const isAllowedHost = isQA() || isGoggles();
  if (!isAllowedHost) {
    return false;
  }
  if (shouldSkipLocal()) {
    return false;
  }
  try {
    const services = await fetchLocalServicesCached();
    return services.some(s => s.name === serviceName);
  } catch (_unused3) {
    return false;
  }
}
export function shouldForce401() {
  return getSessionStorageFlag(CHIRP_FORCE_401_KEY);
}